module.exports = __webpack_public_path__ + "static/media/spacehologram_1.8ba0f172.jpg";